// extracted by mini-css-extract-plugin
module.exports = {"headerImage":"HeaderSection_headerImage__X7ADJ","kv":"HeaderSection_kv__dShix","cta":"HeaderSection_cta__28jJz"};